export default __webpack_public_path__ + "static/media/date_range.8e3fcd95.svg";